


































import axios from 'axios';
import moment from 'moment-timezone';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

import { BaseVue } from '@/BaseVue';
import CreateInventoryView from '@/components/inventory/CreateInventoryView.vue';
import UiAlert from '@/components/ui/UiAlert.vue';
import UiButton from '@/components/ui/UiButton.vue';
import UiButtonToggle from '@/components/ui/UiButtonToggle.vue';
import UiCheckbox from '@/components/ui/UiCheckbox.vue';
import UiDataTable from '@/components/ui/UiDataTable.vue';
import UiDatePicker from '@/components/ui/UiDatePicker.vue';
import WalletListNew from '@/components/wallets/WalletListNew.vue';
import { getClusterAwareBaseUrl } from '@/utils/clusterAwareUrl';
import { clearDownloadIframes, downloadAuthorizedFile } from '@/utils/downloadFile';
import numberUtils from '@/utils/numberUtils';

import { baConfig } from '../../../../config';
import { ApiSvcInventoryView, InventoryApi } from '../../../../generated/api-svc';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface GenericResponseAxios {
  status?: string[];
  exportIds?: any[];
}

@Component({
  components: {
    UiCheckbox,
    UiButtonToggle,
    CreateInventoryView,
    UiDatePicker,
    UiButton,
    WalletListNew,
    UiDataTable,
    UiAlert,
  },
})
export default class InventoryViewReport extends BaseVue {
  @Prop({ default: null })
  public readonly view!: ApiSvcInventoryView | null;

  @Prop({ default: null })
  public readonly reportName!: string;

  public startDate = moment.tz(moment.tz.guess()).subtract(1, 'day').format('YYYY-MM-DD');
  public endDate = moment.tz(moment.tz.guess()).subtract(1, 'day').format('YYYY-MM-DD');
  public numFormat = numberUtils.getFormatter({ accountingNegative: true });
  public csvLoading = false;
  public baseUrl = getClusterAwareBaseUrl(process.env.VUE_APP_RPT_API_URL ?? process.env.VUE_APP_API_URL!);
  public errorMessage: string | null = null;
  public actionsSummaryGranularity: 'daily' | 'weekly' | 'monthly' | 'yearly' | 'total' = 'monthly';
  public includeInternalTransfers = false;
  public actionsSummaryGranularityOptions = [
    { value: 'Daily', id: 'daily' },
    { value: 'Weekly', id: 'weekly' },
    { value: 'Monthly', id: 'monthly' },
    { value: 'Yearly', id: 'yearly' },
    { value: 'Total', id: 'total' },
  ];

  downloadFile = downloadAuthorizedFile;

  public get isActionsSummaryReport() {
    return this.reportName === 'actions-summary-report';
  }

  public setActionsSummaryGranularity(granularity: string | number) {
    if (
      granularity === 'daily' ||
      granularity === 'weekly' ||
      granularity === 'monthly' ||
      granularity === 'yearly' ||
      granularity === 'total'
    ) {
      this.actionsSummaryGranularity = granularity;
    }
  }

  async downloadReport() {
    if (this.view && this.view.id) {
      this.csvLoading = true;

      try {
        const svc = new InventoryApi(undefined, baConfig.getFriendlyApiUrl());
        let promiseCall: Promise<any> | null = null;

        switch (this.reportName) {
          case 'je-reclass':
            promiseCall = svc.getInventoryJeReclass(this.orgId, this.view.id, this.startDate, this.endDate, true, {
              withCredentials: true,
            });
            break;
          case 'sage-erp-je-import':
            promiseCall = svc.getSageErpJeReport(this.orgId, this.view.id, this.startDate, this.endDate, {
              withCredentials: true,
            });
            break;
          case 'expanded-actions-report':
            promiseCall = svc.getAdvancedActionsReport(this.orgId, this.view.id, this.startDate, this.endDate, {
              withCredentials: true,
            });
            break;
          case 'actions-summary-report':
            promiseCall = axios.get(
              `${baConfig.getFriendlyApiUrl()}/orgs/${this.orgId}/inventory-views/${
                this.view.id
              }/reports/actions-summary-report`,
              {
                params: {
                  startDate: this.startDate,
                  endDate: this.endDate,
                  granularity: this.actionsSummaryGranularity,
                  includeInternalTransfers: this.includeInternalTransfers,
                  exportResults: true,
                },
                withCredentials: true,
              }
            );
            break;
          case 'actions-je-report':
            promiseCall = svc.getActionsJeReport(this.orgId, this.view.id, this.startDate, this.endDate, {
              withCredentials: true,
            });
            break;
          case 'actions-tb-report':
            promiseCall = svc.getActionsTrialBalanceReport(this.orgId, this.view.id, this.startDate, this.endDate, {
              withCredentials: true,
            });
            break;
        }

        const resp = await promiseCall;

        if (resp && resp.status === 200) {
          const exportIds = resp.data.exportIds || [];
          const downloadUrlPromises = [] as any[];
          exportIds?.forEach((x: any) => {
            downloadUrlPromises.push(
              axios.get(`${this.baseUrl}v2/orgs/${this.$store.state.currentOrg.id}/exports/${x}?rawUrl=true`, {
                withCredentials: true,
              })
            );
          });
          clearDownloadIframes();
          const downloadUrls = await Promise.all(downloadUrlPromises);
          downloadUrls.forEach((x: any) => {
            this.downloadFile(x.data);
          });
        }
      } catch (error) {
        this.errorMessage = 'An error occurred while downloading the report.';
      } finally {
        this.csvLoading = false;
      }
    }
  }
}
